"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateLinearMatrix = generateLinearMatrix;
exports.getChartCategorialColorsByIndex = getChartCategorialColorsByIndex;
exports.getChartLinearColorByIndex = getChartLinearColorByIndex;
exports.default = exports.linearColorMatrix = exports.chartLinearColors = exports.chartCategorialColors = exports.colors = exports.variables = void 0;

var _each2 = _interopRequireDefault(require("lodash/each"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-webpack-loader-syntax */
"use strict";

var Variables = {
  "black": "#000000",
  "semi-black": "#1b2025",
  "dark-gray-1": "#22272e",
  "dark-gray-2": "#37414b",
  "dark-gray-3": "#4d5969",
  "gray-1": "#627386",
  "gray-2": "#7c8d9f",
  "gray-3": "#9aa5b5",
  "light-gray-1": "#b8bfca",
  "light-gray-2": "#d5dae0",
  "light-gray-3": "#f2f4f6",
  "semi-white": "#f8f9fa",
  "white": "#ffffff",
  "dark-blue-1": "#1856ad",
  "dark-blue-2": "#1b6dc6",
  "dark-blue-3": "#1f88de",
  "blue-1": "#22a5f7",
  "blue-2": "#59bcf9",
  "blue-3": "#91d2fb",
  "light-blue-1": "#bde4fd",
  "light-blue-2": "#d3edfd",
  "light-blue-3": "#e9f6fe",
  "semi-white-blue": "#f4fbff",
  "dark-red-1": "#ab3c52",
  "dark-red-2": "#c44556",
  "dark-red-3": "#dc4d57",
  "red-1": "#f55656",
  "red-2": "#f88080",
  "red-3": "#faabab",
  "light-red-1": "#fccccc",
  "light-red-2": "#fddddd",
  "light-red-3": "#feeeee",
  "semi-white-red": "#fff7f7",
  "dark-yellow-1": "#b36108",
  "dark-yellow-2": "#cc7c09",
  "dark-yellow-3": "#e69b0a",
  "yellow-1": "#ffbc0b",
  "yellow-2": "#ffcd48",
  "yellow-3": "#ffde85",
  "light-yellow-1": "#ffebb6",
  "light-yellow-2": "#fff2ce",
  "light-yellow-3": "#fff8e7",
  "semi-white-yellow": "#fffcf3",
  "dark-green-1": "#26925e",
  "dark-green-2": "#2ba664",
  "dark-green-3": "#31bb67",
  "green-1": "#36d068",
  "green-2": "#68dc8e",
  "green-3": "#9be8b4",
  "light-green-1": "#c3f1d2",
  "light-green-2": "#d7f6e1",
  "light-green-3": "#ebfaf0",
  "semi-white-green": "#f5fdf7",
  "font-color-1": "#22272e",
  "font-color-2": "#627386",
  "font-color-3": "#7c8d9f",
  "font-color-4": "#9aa5b5",
  "border-color-1": "#b8bfca",
  "border-color-2": "#d5dae0",
  "border-color-3": "#f2f4f6",
  "background-color-1": "#22272e",
  "background-color-2": "#37414b",
  "background-color-3": "#4d5969",
  "background-color-4": "#f2f4f6",
  "classPrefix": "ntnx",
  "default-font-family": "'Ntnx', Helvetica Neue, Helvetica, Arial, sans-serif",
  "monospace-font-family": "Menlo-Regular",
  "font-weight-fine": "200",
  "font-weight-thin": "300",
  "font-weight-regular": "400",
  "font-weight-medium": "500",
  "font-weight-semi-bold": "600",
  "font-weight-bold": "700",
  "default-font-size": "14px",
  "default-monospace-font-size": "12px",
  "default-background-color": "#ffffff",
  "title-font-color": "#22272e",
  "title-h1-font-size": "29px",
  "title-h1-font-weight": "300",
  "title-h1-line-height": "20px",
  "title-h1-multiline-height": "35px",
  "title-h2-font-size": "18px",
  "title-h2-font-weight": "400",
  "title-h2-line-height": "12px",
  "title-h2-multiline-height": "22px",
  "title-h3-font-size": "14px",
  "title-h3-font-weight": "600",
  "title-h3-line-height": "10px",
  "title-h3-multiline-height": "17px",
  "title-h4-font-color": "#627386",
  "title-h4-font-size": "12px",
  "title-h4-font-weight": "500",
  "title-h4-line-height": "8px",
  "title-h4-multiline-height": "15px",
  "paragraph-font-size": "14px",
  "paragraph-font-weight": "400",
  "paragraph-font-color": "#22272e",
  "paragraph-font-color-white": "#ffffff",
  "paragraph-line-height": "10px",
  "paragraph-multi-line-height": "22px",
  "label-font-size": "14px",
  "label-font-weight": "400",
  "label-line-height": "10px",
  "label-info-font-color": "#9aa5b5",
  "label-info-dark-font-color": "#627386",
  "label-primary-font-color": "#22272e",
  "label-secondary-font-color": "#627386",
  "label-white-font-color": "#ffffff",
  "link-font-size": "14px",
  "link-font-weight": "500",
  "link-line-height": "10px",
  "link-primary-font-color": "#22a5f7",
  "link-delete-font-color": "#f55656",
  "link-info-font-color": "#9aa5b5",
  "link-primary-disable-font-color": "#bde4fd",
  "link-delete-disable-font-color": "#fccccc",
  "link-info-disable-font-color": "#d5dae0",
  "tag-font-size": "12px",
  "tag-font-weight": "500",
  "tag-line-height": "8px",
  "tag-font-weight-white": "600",
  "tag-font-color-white": "#ffffff",
  "tag-font-color-dark": "#627386",
  "tag-font-color-red": "#f55656",
  "tag-font-color-blue": "#22a5f7",
  "tag-font-color-info": "#9aa5b5",
  "Select-font-color": "#22272e",
  "Select-font-size": "14px",
  "Select-font-weight": "500",
  "Select-line-height": "20px",
  "navbar-min-height": "60px",
  "sidebar-min-width": "240px",
  "disabled-opacity": "0.3"
};

"use strict";

var Colors = {
  "black": "#000000",
  "semi-black": "#1b2025",
  "dark-gray-1": "#22272e",
  "dark-gray-2": "#37414b",
  "dark-gray-3": "#4d5969",
  "gray-1": "#627386",
  "gray-2": "#7c8d9f",
  "gray-3": "#9aa5b5",
  "light-gray-1": "#b8bfca",
  "light-gray-2": "#d5dae0",
  "light-gray-3": "#f2f4f6",
  "semi-white": "#f8f9fa",
  "white": "#ffffff",
  "dark-blue-1": "#1856ad",
  "dark-blue-2": "#1b6dc6",
  "dark-blue-3": "#1f88de",
  "blue-1": "#22a5f7",
  "blue-2": "#59bcf9",
  "blue-3": "#91d2fb",
  "light-blue-1": "#bde4fd",
  "light-blue-2": "#d3edfd",
  "light-blue-3": "#e9f6fe",
  "semi-white-blue": "#f4fbff",
  "dark-red-1": "#ab3c52",
  "dark-red-2": "#c44556",
  "dark-red-3": "#dc4d57",
  "red-1": "#f55656",
  "red-2": "#f88080",
  "red-3": "#faabab",
  "light-red-1": "#fccccc",
  "light-red-2": "#fddddd",
  "light-red-3": "#feeeee",
  "semi-white-red": "#fff7f7",
  "dark-yellow-1": "#b36108",
  "dark-yellow-2": "#cc7c09",
  "dark-yellow-3": "#e69b0a",
  "yellow-1": "#ffbc0b",
  "yellow-2": "#ffcd48",
  "yellow-3": "#ffde85",
  "light-yellow-1": "#ffebb6",
  "light-yellow-2": "#fff2ce",
  "light-yellow-3": "#fff8e7",
  "semi-white-yellow": "#fffcf3",
  "dark-green-1": "#26925e",
  "dark-green-2": "#2ba664",
  "dark-green-3": "#31bb67",
  "green-1": "#36d068",
  "green-2": "#68dc8e",
  "green-3": "#9be8b4",
  "light-green-1": "#c3f1d2",
  "light-green-2": "#d7f6e1",
  "light-green-3": "#ebfaf0",
  "semi-white-green": "#f5fdf7",
  "font-color-1": "#22272e",
  "font-color-2": "#627386",
  "font-color-3": "#7c8d9f",
  "font-color-4": "#9aa5b5",
  "border-color-1": "#b8bfca",
  "border-color-2": "#d5dae0",
  "border-color-3": "#f2f4f6",
  "background-color-1": "#22272e",
  "background-color-2": "#37414b",
  "background-color-3": "#4d5969",
  "background-color-4": "#f2f4f6"
};

"use strict";

var ChartCategorialColors = {
  "categorial-color-1": "#22a5f7",
  "categorial-color-2": "#8a77ed",
  "categorial-color-3": "#36d068",
  "categorial-color-4": "#ffbc0b",
  "categorial-color-5": "#f25c61",
  "categorial-color-6": "#33d6cb",
  "categorial-color-7": "#ed5fb4",
  "categorial-color-8": "#ff8e3d"
};

"use strict";

var ChartLinearColors = {
  "linear-1-color": "#22a5f7",
  "linear-2-1-color": "#4078e9",
  "linear-2-2-color": "#56bce2",
  "linear-3-1-color": "#456ee6",
  "linear-3-2-color": "#22a4f7",
  "linear-3-3-color": "#61c1dd",
  "linear-4-1-color": "#5753dd",
  "linear-4-2-color": "#348aef",
  "linear-4-3-color": "#41b3ea",
  "linear-4-4-color": "#81cfd1",
  "linear-5-1-color": "#5d4bdb",
  "linear-5-2-color": "#4078e9",
  "linear-5-3-color": "#23a5f7",
  "linear-5-4-color": "#56bce1",
  "linear-5-5-color": "#8bd3cc",
  "linear-6-1-color": "#6143d8",
  "linear-6-2-color": "#486ae4",
  "linear-6-3-color": "#2f91f1",
  "linear-6-4-color": "#39afee",
  "linear-6-5-color": "#65c2db",
  "linear-6-6-color": "#92d7c9",
  "linear-7-1-color": "#643fd7",
  "linear-7-2-color": "#4e61e2",
  "linear-7-3-color": "#3883ec",
  "linear-7-4-color": "#23a5f7",
  "linear-7-5-color": "#4ab7e7",
  "linear-7-6-color": "#71c8d7",
  "linear-7-7-color": "#98d9c7",
  "linear-8-1-color": "#673bd6",
  "linear-8-2-color": "#535ae0",
  "linear-8-3-color": "#3f77e9",
  "linear-8-4-color": "#2c96f2",
  "linear-8-5-color": "#34adf0",
  "linear-8-6-color": "#56bce1",
  "linear-8-7-color": "#7accd4",
  "linear-8-8-color": "#9ddbc6"
};

/* eslint-enable */

// Running build-cjs complains about imported modules not being declared after upgrading babel (v7.2.0)
// Declaring here as a workaround
var variables = Variables;
exports.variables = variables;
var colors = Colors;
exports.colors = colors;
var chartCategorialColors = ChartCategorialColors;
exports.chartCategorialColors = chartCategorialColors;
var chartLinearColors = ChartLinearColors;
exports.chartLinearColors = chartLinearColors;

/**
 * Generate 2D arrays from the chartLinearColors variables
 * with the first index being the metric index and the
 * second index being the color index.
 * @return {array} - 2D arrays
 *
 * The end result would look something like this.
 * 1:["#22A5F7"]
 * 2:["#4078E9", "#56BCE2"]
 * 3:["#456EE6", "#22A4F7", "#61C1DD"]
 * 4:["#5753DD", "#348AEF", "#41B3EA", "#81CFD1"]
 * 5:["#5D4BDB", "#4078E9", "#23A5F7", "#56BCE1", "#8BD3CC"]
 * 6:["#6143D8", "#486AE4", "#2F91F1", "#39AFEE", "#65C2DB", "#92D7C9"]
 * 7:["#643FD7", "#4E61E2", "#3883EC", "#23A5F7", "#4AB7E7", "#71C8D7", "#98D9C7"]
 * 8:["#673BD6", "#535AE0", "#3F77E9", "#2C96F2", "#34ADF0", "#7ACCD4", "#9DDBC6"]
 */
function generateLinearMatrix() {
  var colorMetrics = [];
  (0, _each2.default)(chartLinearColors, function (colorHash, colorVariable) {
    var metricIndex = /linear-(\d)-.*/g.exec(colorVariable)[1];

    if (!colorMetrics[metricIndex]) {
      colorMetrics[metricIndex] = [];
    }

    colorMetrics[metricIndex].push(colorHash);
  });
  return colorMetrics;
}

var linearColorMatrix = generateLinearMatrix();
/**
 * Given a number return a color hash value from the 8 supported
 * categorial colors.  See http://nutanix.design/2.0/#Diagrams_Colors
 *
 * @param {number} index - positive number.  A number larger than 7 will wrap.
 *   For example 8 is the same color as index 0, and 9 is the color as index 1
 *   and so on.
 * @returns {string} - color hash value.
 */

exports.linearColorMatrix = linearColorMatrix;

function getChartCategorialColorsByIndex(index) {
  var colorKeys = Object.keys(chartCategorialColors);
  var totalPrimaryColors = colorKeys.length;
  var colorIndex = (totalPrimaryColors + index) % totalPrimaryColors;
  return chartCategorialColors[colorKeys[colorIndex]];
}
/**
 * Return a color hash value based on the input index and metricLength
 *
 * @param {number} index - Which color to choose from the given length.
 * @param {number} metricLength - (1-8) To refer to which color linear
 *   metric to use.  See http://nutanix.design/2.0/#Diagrams_Colors.
 *   NOTE: Currently the maximum support metricLenght is 8.
 * @return {string} - color hash
 */


function getChartLinearColorByIndex(index, metricLength) {
  return linearColorMatrix[metricLength][index];
}

var _default = {
  getChartLinearColorByIndex: getChartLinearColorByIndex,
  getChartCategorialColorsByIndex: getChartCategorialColorsByIndex,
  linearColorMatrix: linearColorMatrix,
  generateLinearMatrix: generateLinearMatrix,
  colors: colors,
  chartCategorialColors: chartCategorialColors,
  chartLinearColors: chartLinearColors
};
exports.default = _default;